import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step14 from './Step14-redux';

export default compose(
  withRouter,
  withNextStep
)(Step14);
